module.exports = __webpack_public_path__ + "static/media/1995 Seoul, Korea.c214cc19.jpg";